import React, { useEffect, useState } from 'react'
import logo from "../../assets/images/therame.svg";
export default function Privacypolicy() {
    document.title="Therame-Privacy Policy"
    useEffect(() => {
        document.body.style.backgroundColor = "#252735";
        return () => {
            document.body.style.backgroundColor = "";
        };
    }, []);
    return (
        <>
        <div className="container-fluid px-0">
            <div className="container-fluid py-3" style={{ backgroundColor: '#1d1e28' }}>
                <img src={logo} width="232" alt="The TEA Group Logo" />
            </div>
        </div>

        <div className="container-fluid p-5 text-white">
            <h3 className="">The TEA Group Privacy Policy</h3>
            <p className="">
                We value your privacy. This policy explains how we collect and use your information when you visit our website (
                <a href="https://www.theteagroup.org" className="text-decoration-none text-white">www.theteagroup.org</a>) or use our apps.
            </p>
            
            <h4>Information We Collect</h4>
            <ul>
                <li>We collect the information you provide, like your name, email, and phone number.</li>
                <li>We collect information automatically, like your IP address and browser details. This helps us understand how people use our site.</li>
            </ul>
            
            <h4>How We Use Your Information</h4>
            <ul>
                <li>To provide and improve our website and apps.</li>
                <li>To communicate with you.</li>
                <li>To prevent fraud.</li>
            </ul>
            
            <h4>Sharing Your Information</h4>
            <ul>
                <li>We don't share your personal information with third-party advertisers.</li>
                <li>Other websites have their own privacy policies.</li>
            </ul>
            
            <h4>Your Rights</h4>
            <ul>
                <li>You can access, correct, or delete your data.</li>
                <li>You can object to how we use your data.</li>
                <li>Contact us to exercise these rights.</li>
            </ul>
            
            <h4>Children's Privacy</h4>
            
            <ul>
            <li>We don't collect information from children under 13.</li>

            </ul>
            
            <h4>Cookies</h4>
            <ul>
                
            <li>We use cookies to improve your experience on our site.</li>
            </ul>
            
            <h4>Consent</h4>
            <ul>
                
            <li>By using our website or apps, you agree to this Privacy Policy.</li>
            </ul>
            
            <h4>Contact Us</h4>
            <ul>
                
            <li>If you have questions, contact us at <a href="mailto:info@theteagroup.org" className="text-decoration-none text-white">info@theteagroup.org</a>.</li>
            </ul>
            
            <h4>Changes</h4>
            <ul>
                
            <li>We may update this policy. We'll notify you of significant changes.</li>
            </ul>
        </div>
    </>
);
}

   
